import React from "react";
import PropTypes from "prop-types";

import { useTrans } from "../../../../hooks";
import ContestFormField from "../ContestFormField";
import { MAP_AI_USAGE } from "../constants";
import { NewCheckbox } from "../../../../shared-components";
import ErrorField from "./ErrorField";

const AIDisclaimerField = ({
  form,
  disableForm,
  onAIDisclaimerChange,
  requiredAIDisclaimerError,
  fieldStatus,
  submitted
}) => {
  const { trans } = useTrans();

  const title = trans("Artificial intelligence");

  const subtitle = (
    <div className="subtitle">
      {trans(
        "Did you use Artificial Intelligence (AI) tools during the creation of this story? If so, please select the option(s) that best describe(s) how it was used:"
      )}
    </div>
  );

  const errorMessage =
    requiredAIDisclaimerError && !disableForm
      ? trans("You must pick at least 1")
      : "";

  const errorCondition =
    !requiredAIDisclaimerError &&
    (fieldStatus.fieldInvalid ||
      (fieldStatus.fieldName !== "aiDisclaimer" &&
        fieldStatus.fieldName !== "" &&
        submitted)) &&
    form.aiDisclaimer.length === 0;

  return (
    <ContestFormField title={title} subtitle={subtitle}>
      <div id="ai-disclaimer">
        {MAP_AI_USAGE(trans).map(option => (
          <div className="checkbox-group" key={option.key}>
            <NewCheckbox
              name={option.key}
              disabled={disableForm}
              onChange={onAIDisclaimerChange}
              contentId={`ai-disclaimer-${option.key}`}
              checked={form.aiDisclaimer.includes(option.key)}
            >
              {option.value}
            </NewCheckbox>
          </div>
        ))}

        <ErrorField
          errorMessage={errorMessage}
          errorCondition={errorCondition}
          fieldId={"ai-disclaimer"}
        />
      </div>
    </ContestFormField>
  );
};

AIDisclaimerField.propTypes = {
  form: PropTypes.object.isRequired,
  disableForm: PropTypes.bool.isRequired,
  onAIDisclaimerChange: PropTypes.func.isRequired,
  requiredAIDisclaimerError: PropTypes.bool.isRequired,
  fieldStatus: PropTypes.shape({
    fieldInvalid: PropTypes.bool,
    fieldName: PropTypes.string
  }).isRequired,
  submitted: PropTypes.bool.isRequired
};

export default AIDisclaimerField;
